"use client";

import * as React from "react";
import { GallerySection11 } from "./gallery-section-11";

type CardsSliderVerticalProps = React.ComponentProps<typeof GallerySection11>;

export function CardsSliderVertical(props: CardsSliderVerticalProps) {
  return <GallerySection11 {...props} />;
}

CardsSliderVertical.displayName = "Cards Slider Vertical";
